import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"width":"100%","height":"100%"},
  class: "overflow-auto pb-16px"
}
const _hoisted_2 = { class: "tabcont" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center justify-between mb-[16px]"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 0,
  class: "tabcont"
}
const _hoisted_6 = {
  key: 0,
  class: "tabcont"
}
const _hoisted_7 = {
  key: 0,
  class: "tabcont"
}

import { ElTabs, ElTabPane, ElEmpty } from 'element-plus'
import { ref, nextTick, computed } from 'vue'
// @ts-ignore
import collectList from './collectList.vue'
// @ts-ignore
import recommendSection from './recommendSection.vue'
// @ts-ignore
import elementlist from './elementlist.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props, { expose: __expose }) {

const activeName = ref('first')
const searchkwords = ref('')
const collectitemsShow = ref(false)
const hasQuery = computed(() => searchkwords.value.trim() !== '')

const collectionNum = ref(0)
const recommend = ref<any[]>([])
const collectcategory = ref<Record<string, any>>({})
const openCollect = (item: Record<string, any>, switchTab = false) => {
  collectcategory.value = item
  if (switchTab) activeName.value = 'second'
  collectitemsShow.value = true
}
const handleRecommendMore = (item) => {
  console.log(item)
  activeName.value = item.id
  // recommend.value = (Array.isArray(num) ? num : []).filter((item: any) => item?.materials?.length > 0)
}



const handleNum = (num: any, type: string) => {
  if (type === 'collect') {
    collectionNum.value = num
  } else if (type === 'recommend') {
    recommend.value = (Array.isArray(num) ? num : []).filter((item: any) => item?.materials?.length > 0)
  }
}



const searchList = (searchValue: string) => {
  activeName.value = 'first'
  searchkwords.value = ''
  nextTick(() => {
    searchkwords.value = searchValue
  })
}
const handleMore = (type: string) => {
  if (type === 'collect') {
    activeName.value = 'second'
  } else if (type === 'recommend') {
  }
}
__expose({ searchList })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(ElTabs), {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeName).value = $event)),
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTabPane), {
            label: "全部",
            name: "first",
            style: {"height":"calc(100% - 48px)"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (collectionNum.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-ellipsis whitespace-nowrap overflow-hidden font-bold" }, "合集", -1)),
                      _createElementVNode("div", {
                        class: "more cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleMore('collect')))
                      }, "更多")
                    ]))
                  : _createCommentVNode("", true),
                (hasQuery.value)
                  ? (_openBlock(), _createBlock(collectList, {
                      key: 1,
                      showNum: 2,
                      searchkwords: searchkwords.value,
                      onSelectMore: _cache[1] || (_cache[1] = ($event: any) => (openCollect($event, true))),
                      onNum: _cache[2] || (_cache[2] = ($event: any) => (handleNum($event, 'collect')))
                    }, null, 8, ["searchkwords"]))
                  : _createCommentVNode("", true),
                (hasQuery.value)
                  ? (_openBlock(), _createBlock(recommendSection, {
                      key: 2,
                      searchkwords: searchkwords.value,
                      onNum: _cache[3] || (_cache[3] = ($event: any) => (handleNum($event, 'recommend'))),
                      onMore: _cache[4] || (_cache[4] = ($event: any) => (handleRecommendMore($event, 'recommend')))
                    }, null, 8, ["searchkwords"]))
                  : _createCommentVNode("", true),
                (!collectionNum.value && !recommend.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(ElEmpty), { description: "暂无数据" })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (collectionNum.value)
            ? (_openBlock(), _createBlock(_unref(ElTabPane), {
                key: 0,
                label: "合集",
                name: "second"
              }, {
                default: _withCtx(() => [
                  (hasQuery.value && activeName.value === 'second')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _withDirectives(_createVNode(collectList, {
                          showNum: 0,
                          searchkwords: searchkwords.value,
                          onSelectMore: openCollect
                        }, null, 8, ["searchkwords"]), [
                          [_vShow, !collectitemsShow.value]
                        ]),
                        (collectitemsShow.value)
                          ? (_openBlock(), _createBlock(elementlist, {
                              key: 0,
                              searchValue: searchkwords.value,
                              type: "collect",
                              category: collectcategory.value,
                              onBack: _cache[5] || (_cache[5] = ($event: any) => (collectitemsShow.value = false))
                            }, null, 8, ["searchValue", "category"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommend.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(ElTabPane), {
              label: item.name,
              name: item.id,
              key: index
            }, {
              default: _withCtx(() => [
                (hasQuery.value && activeName.value === item.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(elementlist, {
                        searchValue: searchkwords.value,
                        type: "materials",
                        category: { id: item.id }
                      }, null, 8, ["searchValue", "category"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["label", "name"]))
          }), 128)),
          _createVNode(_unref(ElTabPane), {
            label: "形状",
            name: "fifth"
          }, {
            default: _withCtx(() => [
              (hasQuery.value && activeName.value === 'fifth')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(elementlist, {
                      searchValue: searchkwords.value,
                      type: "svg"
                    }, null, 8, ["searchValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})